import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {AUCTIONEER_PROP_TYPE} from '../utils/props';
import {getBackgroundPhotoOrDefault} from '../utils/photos';

export default class AuctioneerPhoto extends Component {
    static propTypes = {
        className: PropTypes.string,
        auctioneer: AUCTIONEER_PROP_TYPE
    }
    render() {
        let {
            auctioneer,
            className
        } = this.props;
        
        return (
            <div
                className={className}
                style={getBackgroundPhotoOrDefault(auctioneer, 'photoUrl')}
            >
            </div>
        );
    }
}